// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReplyModal_modal__3iC1j","card":"ReplyModal_card__10ZO7","main":"ReplyModal_main__3G299","avatar":"ReplyModal_avatar__adgKr","sending":"ReplyModal_sending__3llb_"};